'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkboxStyle = exports.classicRadioStyle = exports.errorStyle = exports.labelStyle = exports.controlStyle = exports.formStyle = undefined;
var _themeUtilities = require('../theme-utilities');
var _themeUtilities2 = _interopRequireDefault(_themeUtilities);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var formStyle = exports.formStyle = function formStyle() {
  for (var _len = arguments.length, styles = Array(_len), _key = 0; _key < _len; _key++) {
    styles[_key] = arguments[_key];
  }
  return _themeUtilities2.default.apply(undefined, ['Form'].concat(styles));
};
var controlStyle = exports.controlStyle = function controlStyle() {
  for (var _len2 = arguments.length, styles = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    styles[_key2] = arguments[_key2];
  }
  return _themeUtilities2.default.apply(undefined, ['FormControl'].concat(styles));
};
var labelStyle = exports.labelStyle = function labelStyle() {
  for (var _len3 = arguments.length, styles = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    styles[_key3] = arguments[_key3];
  }
  return _themeUtilities2.default.apply(undefined, ['FormLabel'].concat(styles));
};
var errorStyle = exports.errorStyle = function errorStyle() {
  for (var _len4 = arguments.length, styles = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    styles[_key4] = arguments[_key4];
  }
  return _themeUtilities2.default.apply(undefined, ['FormError'].concat(styles));
};
var classicRadioStyle = exports.classicRadioStyle = function classicRadioStyle() {
  for (var _len5 = arguments.length, styles = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    styles[_key5] = arguments[_key5];
  }
  return _themeUtilities2.default.apply(undefined, ['FormClassicRadio'].concat(styles));
};
var checkboxStyle = exports.checkboxStyle = function checkboxStyle() {
  for (var _len6 = arguments.length, styles = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
    styles[_key6] = arguments[_key6];
  }
  return _themeUtilities2.default.apply(undefined, ['FormCheckbox'].concat(styles));
};
var formTheme = function formTheme(baseTheme) {
  var _Object$assign;
  return Object.assign((_Object$assign = {}, _defineProperty(_Object$assign, labelStyle('fontWeight'), baseTheme.fontBold), _defineProperty(_Object$assign, controlStyle('backgroundColor'), baseTheme.colorWhite), _defineProperty(_Object$assign, errorStyle('color'), baseTheme.colorDangerDark), _defineProperty(_Object$assign, checkboxStyle('marginTop'), '4px'), _defineProperty(_Object$assign, checkboxStyle('color'), baseTheme.colorBlack), _defineProperty(_Object$assign, checkboxStyle('backgroundColor'), baseTheme.colorWhite), _defineProperty(_Object$assign, checkboxStyle('color', 'selected'), '#219E3E'), _defineProperty(_Object$assign, classicRadioStyle('marginTop'), '3px'), _defineProperty(_Object$assign, classicRadioStyle('color'), '#5c6770'), _defineProperty(_Object$assign, classicRadioStyle('color', 'selected'), '#219E3E'), _defineProperty(_Object$assign, classicRadioStyle('backgroundColor'), '#ebebeb'), _defineProperty(_Object$assign, classicRadioStyle('backgroundColor', 'selected'), baseTheme.colorWhite), _Object$assign), baseTheme);
};
var offWhiteInputTheme = function offWhiteInputTheme(baseTheme) {
  return _defineProperty({}, controlStyle('backgroundColor'), baseTheme.colorOffWhite);
};
exports.default = {
  formTheme: formTheme,
  offWhiteInputTheme: offWhiteInputTheme,
  formStyle: formStyle,
  labelStyle: labelStyle,
  errorStyle: errorStyle,
  classicRadioStyle: classicRadioStyle,
  checkboxStyle: checkboxStyle,
  controlStyle: controlStyle
};